import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SvcHttpClient } from 'projects/lib-shared-common/src/lib/classes/svc-http-client';
import { AppEnvironmentConfig } from 'projects/config/model/environment.config.model';
import { SitesService, UserService } from 'projects/lib-shared-core/src/public-api';
import { SvcDialogService } from '@solvace/component/svc-dialogs';
import { BosDrilldownData, BosDrilldownFilter } from '../interfaces/svc-modal-bos.interface';
import { SvcModalBosComponent } from '../../svc-modal-bos.component';
import { SvcModalBosType } from '../enums/svc-modal-bos.enum';
import { appendCustomFieldParams } from '../utils/bos-filter.utils';

@Injectable({
  providedIn: 'root',
})
export class BosHttpClient extends SvcHttpClient {
  private userService: UserService = inject(UserService);

  public get siteId(): number {
    return this.userService.user.lastSiteId;
  }

  private readonly _apiUrlBos: string = this.appConfig.APIs.apiUrlBOS;

  constructor(
    private appConfig: AppEnvironmentConfig,
    private _dialogService: SvcDialogService,
    private httpClient: HttpClient,
    private sitesService: SitesService
  ) {
    super(appConfig.APIs.apiUrlBOS, httpClient);
  }

  private getParams(filter: any, params: HttpParams, key: string): HttpParams {
    const value = filter?.[key];

    if (value === undefined || value === null) {
      return params;
    }

    if (Array.isArray(value)) value.forEach((val: any) => (params = params.append(`${key}`, val)));
    else if (key === 'customField' && typeof value === 'object') {
      params = appendCustomFieldParams(params, key, value);
    }
    else params = params.append(key, value);

    return params;
  }
  b;
  public getBosDataListParams(filter: BosDrilldownFilter): HttpParams {
    let params = new HttpParams();
    Object.keys(filter)?.forEach((key: string) => {
      if (filter?.[key] || key === 'pageIndex') params = this.getParams(filter, params, key);
    });

    params = params.append('siteId', this.sitesService.currentSite.siteId);

    return params;
  }

  public getRequestParams(filter: any): HttpParams {
    let params = new HttpParams();
    Object.keys(filter)?.forEach((key: string) => {
      if (filter?.[key] || key === 'pageIndex') params = this.getParams(filter, params, key);
    });

    params = params.append('siteId', this.siteId);

    return params;
  }

  public getBosDrilldown(filter: BosDrilldownFilter): Observable<BosDrilldownData> {
    const params = this.getBosDataListParams(filter);

    return this.httpClient.get<BosDrilldownData>(`${this._apiUrlBos}/Feedback/ListDrillDown`, {
      params,
    });
  }

  public openBos(mode: SvcModalBosType, id?: number): void {
    this._dialogService.open(SvcModalBosComponent, {
      data: { mode, id },
      width: '100%',
      maxWidth: '500px',
      panelClass: 'md:py-4',
      autoFocus: false,
    });
  }
}
